import(/* webpackMode: "eager" */ "/opt/build/repo/app/(auth)/register/page.tsx")